import styles from './styles/Subs.wrapper.module.scss';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAlgoliaDataStateContext } from '../../../hooks/useAlgoliaDataStateContext';
import { useHierarchyContext } from '../../../hooks/useHierarchyContext';
import { SubTabs } from './SubTabs';
import { SubItems } from './SubItems';
import { SubItemsSkeleton } from './SubItems.skeleton';
import { SubTabsSkeleton } from './SubTabs.skeleton';
export const SubsWrapper = () => {
    const { handle = '' } = useParams();
    const { loading: dLoading } = useAlgoliaDataStateContext();
    const { objects, loading: hLoading } = useHierarchyContext();
    let content;
    if (hLoading || dLoading) {
        content = React.createElement(SubItemsSkeleton, null);
        if (objects[handle]?.subcollectionsAsTabs) {
            content = React.createElement(SubTabsSkeleton, null);
        }
    }
    else {
        const { children, subcollectionsAsTabs } = objects[handle];
        content = subcollectionsAsTabs
            ? React.createElement(SubTabs, { itemHandles: children })
            : React.createElement(SubItems, { itemHandles: children });
    }
    return (React.createElement("div", { className: styles.wrapper }, content));
};
